export const burgerMenu = () => {
  const burgerMenu = document.querySelector(".pw-burger-menu");
  const menu = document.querySelector(".pw-main-menu");

  if (!burgerMenu) return;

  if (!menu) return;

  burgerMenu.addEventListener("click", function (e) {
    burgerMenu.classList.toggle("pw-burger-menu--opened");
    menu.classList.toggle("pw-main-menu--opened");
  });
  
  menu.addEventListener('click', function(event) {
    if (menu.contains(event.target)) {
      burgerMenu.classList.toggle("pw-burger-menu--opened");
      menu.classList.toggle("pw-main-menu--opened");
    }
  });
}
